import { z } from "zod";
export const HealthStatusSchema = z.object({
    status: z.literal("ok"),
    timestamp: z.string(),
});
